/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";

import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";

const FullDataTable = ({
  tableData,
  TableColumns,
  tableoptions,
  selectRow,
  keyField,
  pagination1,
  rowStyle,
}) => {
  //  No Data Image
  const NoDataIndication = () => (
    <>
      <div className="empty-state">
        <div className="empty-icon">📊</div>
        <h3>No Data Available</h3>
        <p>Adjust your filters or check back later for trading results</p>
      </div>
    </>
  );

  const options = {
    sizePerPage: 10,
    hidePageListOnlyOnePage: true,
    ...tableoptions,
  };

  return (
    <>
      <div className="">
        <BootstrapTable
          keyField={keyField ? keyField : "id"}
          data={tableData}
          columns={TableColumns}
          pagination={!pagination1 ? paginationFactory(options) : ""}
          selectRow={selectRow}
          noDataIndication={() => <NoDataIndication />}
          headerClasses="text-left header-class"
          rowClasses={`text-left`}
          rowStyle={rowStyle}
        />
      </div>
    </>
  );
};

export default FullDataTable;
